export const UserRoute = {
  Dashboard: "/",
  Hosts: "/hosts",
  Clicks: "/clicks",
  Bookings: "/bookings",
  Directions: "/all-directions",
  Auction: "/auction",
  Errors: "/errors",
  FAQCategories: "/faq",
  FAQArticle: "/faq/:slug/",
  Feedbacks: "/feedbacks",
  Debug: "/debug",
  GateTester: "/gate-tester",
  Contact: "/contact",
  Conversions: "/conversions",
  Airlines: "/airlines",
  AirlinesProductivity: "/airlines-productivity",
  Alerts: "/alerts",
  Contacts: "/contact",
  Reports: "/reports",
  ExtendedReport: "/extended-report",
};

export const AdminRoute = {
  Panel: "/admin",
};

export const ApplicationRoute = {
  Base: "/",
  Admin: "/admin",
  Login: "/login",
  NotFound: "/404",
  Forbidden: "/403", // TODO: не уверен что оно нам нужно, лишний раз раскрывает информацию
};
